module.exports = __webpack_public_path__ + "img/菏泽市人民政府-1.33af44f8.png";